// student-routing.module.ts

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AmbulanceComponent } from './ambulance/ambulance.component';
import { AmbulanceProfileEditComponent } from './ambulance-profile-edit/ambulance-profile-edit.component';

import { PharmacyComponent } from './pharmacy/pharmacy.component';
import { PharmacyProfileEditComponent } from './pharmacy-profile-edit/pharmacy-profile-edit.component';

import { LoginGuard } from '../login.guard';

import { PharmacyReviewsComponent } from './pharmacy-reviews/pharmacy-reviews.component';
import { PharmacyOrdersComponent } from './pharmacy-orders/pharmacy-orders.component';
import { PharmacyDiscountsComponent } from './pharmacy-discounts/pharmacy-discounts.component';






const routes: Routes = [
   
    {
        path: 'Ambulance', // do not change it may break the code
        component:AmbulanceComponent ,
        children: [
            {
                path: 'profile-edit', // do not change it is used for dunamic routing after login
                component: AmbulanceProfileEditComponent,
                canActivate: [LoginGuard]
            }
        ] 
    },
    
  
   

];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PartnerRoutingModule { }
